import { getGitValidityError } from '@/react/portainer/gitops/hooks/useGitRepoValidity';
import { useGitRefs } from '@/react/portainer/gitops/queries/useGitRefs';

import type { GitCheckError } from './useGitCheckStatus';
import { EffectiveGitReference } from './useResolvedGitConfig';

export interface UseGitRefCheckParams {
  config: Pick<EffectiveGitReference, 'sourceId' | 'ref'>;
  hasAuth: boolean;
  isConfigLoading: boolean;
}

export function useGitRefCheck({
  config: { sourceId, ref },
  hasAuth,
  isConfigLoading,
}: UseGitRefCheckParams) {
  const query = useGitRefs({ sourceId }, { suppressError: true });

  const found = !!ref && !!query.data && query.data.includes(ref);

  const hasRefError = !isConfigLoading && (!ref || (query.isSuccess && !found));

  const error: GitCheckError | undefined = query.isError
    ? {
        kind: 'repo',
        message: getGitValidityError(query.error, hasAuth),
        rawError: query.error,
      }
    : hasRefError
      ? { kind: 'ref', rawError: query.error }
      : undefined;

  return {
    found,
    isLoading: isConfigLoading || query.isFetching,
    error,
  };
}
